import React from 'react'
import styles from './styles'

const QUES_ANS_LIST = [
  {
    question: 'How much does it cost to use OfferZen?',
    answer: (
      <div>
        <p>
          Our plans are designed for all budgets and team needs. Choose to pay-per-hire or make unlimited hires for a fixed monthly or
          annual cost. Learn more{' '}
          <a target="_blank" className={styles.link} href="https://www.offerzen.com/hire-developers/pricing">
            about our pricing
          </a>
          .
        </p>
        <br />
        <p>Join over 2000 teams already hiring software developers on OfferZen.</p>
        <br />
        <p>
          Want to try OfferZen?{' '}
          <a target="_blank" className={styles.link} href="https://www.offerzen.com/hire/get-started">
            Sign up
          </a>{' '}
          to browse active developers. No payment or credit card required.
        </p>
      </div>
    ),
    sourceDetail: 'request access',
  },
  {
    question: 'Are the candidates above real candidates?',
    answer: (
      <p>
        Yes, these are real candidates that are live on OfferZen right now. We regularly update this list to reflect the latest candidates.
        <br />
        <br />
        We anonymise their information to protect their privacy. But we show just enough to give you an idea of their skills. To unlock full
        profiles,{' '}
        <a target="_blank" className={styles.link} href="https://www.offerzen.com/hire/get-started">
         sign up to OfferZen.
        </a>
      </p>
    ),
    sourceDetail: 'real candidates',
  },
  {
    question: 'How do I reach out to these candidates?',
    answer: (
      <p>
        You can only start reaching out to these candidates once you get access to OfferZen. Once you have access, you can use the advanced
        filters to find the best matches and view detailed information on each candidate.{' '}
        <a target="_blank" className={styles.link} href="https://www.offerzen.com/hire/get-started">
          Get access
        </a>{' '}
        to reach out to developers.
      </p>
    ),
    sourceDetail: 'reach out',
  },
  {
    question: 'How does OfferZen source developers?',
    answer: (
      <p>
        OfferZen does not source developers to be on the marketplace. Developers apply to join the platform when they are ready to find a
        new job.
        <br />
        <br />
        That said, we take a community-first approach when it comes to engaging with developers. We do this by providing valuable content
        such as our State of the Developer Nation reports for{' '}
        <a target="_blank" href="https://www.offerzen.com/reports/software-developer-south-africa" className={styles.link}>
          South Africa
        </a>{' '}
        and the{' '}
        <a target="_blank" href="https://www.offerzen.com/reports/software-developer-netherlands" className={styles.link}>
          Netherlands
        </a>
        , as well as organising and sponsoring developer-focused events. Learn more{' '}
        <a target="_blank" href="https://www.offerzen.com/community" className={styles.link}>
          about our community.
        </a>
        <br />
        <br />
        So far, we&apos;ve handed out over 60 000 t-shirts and you&apos;ll see many developers collect those and have multiple OfferZen
        stickers on their laptops. Thanks to this approach, we&apos;ve built a community of over 100 000 developers across South Africa and
        Europe.
      </p>
    ),
    sourceDetail: 'source developers',
  },
  {
    question: 'How does OfferZen curate developers?',
    answer: (
      <>
        <p>
          Thousands of candidates apply to OfferZen on a weekly basis. Every day, our team reviews applicants and only accepts those who
          pass our curation criteria.
          <br />
          <br />
          We curate candidates on two things: Quality and intent (looking for work). Every candidate goes through this process and has to
          speak to someone from our team before they can be listed on OfferZen.
          <br />
          <br />
          To ensure quality, our team curates candidates by:
        </p>
        <ol>
          <li>
            Using an AI-powered algorithm to score how likely the candidate is to be placed on OfferZen, based on their work history,
            education and tech skills.
          </li>
          <li>Checking the available positions on OfferZen for each developer who signs up.</li>
          <li>Matching each accepted candidate with a Talent Advisor who helps them to become visible to companies.</li>
        </ol>
        <p>
          To ensure intent (readiness to move jobs), each developer has a welcome call with their personal Talent Advisor. During this call,
          their Talent Advisor does the following:
        </p>
        <ol>
          <li>Checks for any indication that the candidate is not actually ready to change jobs.</li>
          <li>Reviews their profile to ensure that they are up to OfferZen standard.</li>
          <li>Explains that candidates are required to respond to requests to interview from companies within 48 hours.</li>
        </ol>
      </>
    ),
    sourceDetail: 'curate developers',
  },
]

export default QUES_ANS_LIST
